__turbopack_context__.v({
  "className": "caveat_80653782-module__h8uqOG__className",
});
